import * as React from 'react';

import { PagamentoWithDettaglioDTO } from '@framework/api-client';
import { EnumCodStatoPagamento } from '@framework/frontoffice-submission/src/burden/payments/EnumCodStatoPagamento';
import { ButtonDeleteConfirm } from '@framework/ui';

interface DeletePaymentButtonProps {
  payment: PagamentoWithDettaglioDTO;
}

const CanDeletePaymentStatus: string[] = [
  EnumCodStatoPagamento.DA_PAGARE,
  EnumCodStatoPagamento.FALLIMENTO,
];

export function DeletePaymentButton(props: DeletePaymentButtonProps) {
  // Manca l'endpoint API
  // Al momento non è implementata la cancellazione di un pagamento
  return null;

  const handleClick = () => {};

  if (
    !props.payment.codStatoPagamento ||
    !CanDeletePaymentStatus.includes(
      props.payment.codStatoPagamento as EnumCodStatoPagamento,
    )
  )
    return null;

  return (
    <ButtonDeleteConfirm
      buttonType="default"
      title="Sei sicuro di voler eliminare il pagamento?"
      size="middle"
      buttonDanger
      iconOnlyButton
      disabled={!props.payment.id}
      tooltip="Elimina il pagamento"
      onConfirm={handleClick}
    />
  );
}
